// Переиспользуемые ячейки/карточки вкладок Dashboard.
import React from 'react';

export function Kpi({ label, value, hint, color, highlight }) {
  return (
    <div style={{ background: highlight ? 'var(--choco-900)' : 'var(--surface-card)', border: '1px solid ' + (highlight ? 'var(--choco-900)' : 'var(--border-hairline)'), borderRadius: 'var(--radius-brand)', padding: '20px 24px' }}>
      <div style={{ font: '400 11px/1.2 var(--font-family-display)', letterSpacing: '.14em', textTransform: 'uppercase', color: highlight ? 'var(--satin-300)' : 'var(--choco-300)', marginBottom: 10 }}>{label}</div>
      <div style={{ font: '600 28px/1.1 var(--font-family)', fontVariantNumeric: 'tabular-nums', color: color || (highlight ? 'var(--satin-50)' : 'var(--text-strong)') }}>{value}</div>
      {hint && <div style={{ fontSize: 'var(--text-xs)', color: highlight ? 'var(--satin-300)' : 'var(--text-muted)', marginTop: 4 }}>{hint}</div>}
    </div>
  );
}

export function Num({ children, color, bold }) {
  return (
    <td style={{ padding: '10px 12px', textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap',
      color: color || 'var(--text-secondary)', fontWeight: bold ? 'var(--font-semibold)' : 'var(--font-normal)' }}>
      {children}
    </td>
  );
}
